import { coalesceLocaleField } from '../helpers/coalesceLocaleField'
import { groq } from 'next-sanity'
import { LocaleId } from '@portfolio/configs'

export const createSectionArticlesLandingPageProjection = (
  localeId: LocaleId,
) => {
  return groq`{
        _key,
        _type,
        ${coalesceLocaleField('title', localeId)},
      }
  `
}
